---
en:
  navigation:
    error:
      no_company_selected: No company selected
      too_many_power_plants_selected: Too many power plants selected
    language:
      de: German
      en: English
      fr: French
      nb: Norwegian
      select: Select language
    main_menu:
      admin_market_prices: Market prices
      admin_volumes: Volumes
      admin_weather: Weather forecasts
      api_access: API-access
      api_docs: API-docs
      availability: Availability analysis
      availability_analysis: Availability analysis
      benchmarking: Benchmarking
      budget_forecasts: Budget forecasts
      commercial_scada: Commercial SCADA
      community_access: Community access
      companies: Companies
      components: Components
      contracts: Contracts
      data_export: Data export
      elcert_and_goos: Elcert and GoOs
      elhub: Elhub
      fall_lease: Fall Lease
      feature_requests: Feature Requests
      follow_up: Performance Review
      full_map: Full map
      home: Home
      liquidity_planning: Liquidity Planning
      log_out: Log out
      map: Map
      market_data: Price data
      market_outlook: Forward prices
      market_prices: Historical prices
      marketplace: Marketplace
      more_information: More information
      nest: Nest
      news_items: Posts
      nve_plants: NVE plants
      o_and_m_dashboard_v1: O&M Dashboard v1
      om_dashboard: Dashboard
      operations: Operations
      portfolio: Portfolio
      portfolio_stats: Portfolio statistics
      power_plants: Power plants
      pp_info: Power plant information
      ppa_pricing: PPA Pricing
      production_scheduling: Prod. scheduling
      production_simulation_plan: Production Simulation Plan
      profile: Profile
      public_kiosk_mode: Public kiosk mode
      responsibles: Responsibles
      root: Root
      subsidiaries: Subsidiaries
      suppliers: Suppliers
      task_management: Task management
      users: Users
      white_labeling: White labeling
    production_simulation_plan_query: Run Production Simulation Query
